import { render, staticRenderFns } from "./grafico-new-ux.vue?vue&type=template&id=a5a372b0&"
import script from "./grafico-new-ux.vue?vue&type=script&lang=js&"
export * from "./grafico-new-ux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5a372b0')) {
      api.createRecord('a5a372b0', component.options)
    } else {
      api.reload('a5a372b0', component.options)
    }
    module.hot.accept("./grafico-new-ux.vue?vue&type=template&id=a5a372b0&", function () {
      api.rerender('a5a372b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/grafico-new-ux.vue"
export default component.exports